/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable func-names */

import * as apiServices from "../services/apiServices";
import request from "../services/requestService";
import CookieService from "../services/cookieService";
import { setLocalstorage } from "../helper";
import { LOGIN_ACTION, FORGET_ACTION, PATHS } from "../constant";
import { get } from "lodash";

export const keycloakUserLogin = (loginInfo, cookies) => {
  const { token, userId } = loginInfo;
  const payload = {
    userId: userId,
    token: token
  };

  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.KEYCLOAK_LOGIN_START
    });

    return request(apiServices.keycloakUserLogin(payload))
      .then(loginResp => {
        const payload = loginResp.data;
        setLocalstorage("token", payload.data.jwtToken.accessToken || null);
        setLocalstorage("name", payload.data.user.name || null);
        setLocalstorage("logoDTO", payload.data.user.logoDTO || null);
        setLocalstorage(
          "needHelpEmails",
          payload.data.user.needHelpEmails || null
        );
        setLocalstorage("user", payload.data.user || null);
        setLocalstorage(
          "userSponsoredScheme",
          payload.data.user.sponsoredScheme === "STATE"
        );
        setLocalstorage(
          "draftedProject",
          payload.data.user.projectDrafted || null
        );
        setLocalstorage(
          "groupCategory",
          payload.data.user.groupCategory || null
        );

        setLocalstorage("march24", false);

        if (cookies) {
          _storeLoginInfoInCookie(cookies, loginInfo);
        }
        dispatch({
          type: LOGIN_ACTION.KEYCLOAK_LOGIN_SUCCESS,
          payload
        });
        return loginResp;
      })
      .catch(() => {
        window.location.href = PATHS.ACCESS_DENIED;
      });
  };
};

export const userLogin = (requestMethod = request, loginInfo, cookies) => {
  const { username, encryptedPassword, userID } = loginInfo;
  const payload = {
    userId: username,
    password: encryptedPassword,
    key: userID
  };
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.LOGIN_START
    });
    return requestMethod(apiServices.userLoginParams(payload))
      .then(loginResp => {
        const payload = loginResp.data;
        if (payload.data) {
          setLocalstorage("token", payload.data.jwtToken.accessToken || null);
          setLocalstorage(
            "refreshToken",
            payload.data.jwtToken.refreshToken || null
          );
          setLocalstorage("name", payload.data.user.name || null);
          setLocalstorage("logoDTO", payload.data.user.logoDTO || null);
          setLocalstorage(
            "needHelpEmails",
            payload.data.user.needHelpEmails || null
          );
          setLocalstorage("user", payload.data.user || null);
          setLocalstorage(
            "userSponsoredScheme",
            payload.data.user.sponsoredScheme === "STATE"
          );
          setLocalstorage(
            "draftedProject",
            payload.data.user.projectDrafted || null
          );
          setLocalstorage(
            "groupCategory",
            payload.data.user.groupCategory || null
          );
          window.dispatchEvent(new Event("groupCategoryUpdated"));
        }
        // if (cookies) {
        //   _storeLoginInfoInCookie(cookies, loginInfo);
        // }
        dispatch({
          type: LOGIN_ACTION.LOGIN_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: LOGIN_ACTION.LOGIN_FAILURE
        });
      });
  };
};

export const userSecurityKey = (
  // googleCaptchaToken,
  requestMethod = request
) => {
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.SECURITY_START
    });
    return requestMethod(apiServices._userSecurityKey())
      .then(loginResp => {
        const payload = loginResp.data;
        if (payload) {
          setLocalstorage("_id", payload.id || null);
          setLocalstorage("_key", payload.key || null);
        }
        dispatch({
          type: LOGIN_ACTION.SECURITY_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: LOGIN_ACTION.SECURITY_FAILURE
        });
      });
  };
};

export const userLoginRequest = (payload, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.LOGIN_REQUEST_START
    });
    return requestMethod(apiServices._userLoginRequest(payload))
      .then(loginResp => {
        const data = loginResp.data;
        if (data) {
          setLocalstorage("userId", payload.userId || null);
          setLocalstorage("march24", false);
        }
        dispatch({
          type: LOGIN_ACTION.LOGIN_REQUEST_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(() => {
        dispatch({
          type: LOGIN_ACTION.LOGIN_REQUEST_FAILURE,
          payload: "User doesn't exist"
        });
      });
  };
};

export const userLoginClear = () => {
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.LOGIN_CLEAR
    });
  };
};

export const userLoginWithOTP = (requestMethod = request, loginInfo) => {
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.LOGIN_START
    });
    return requestMethod(apiServices.userLoginWithOTPParams(loginInfo))
      .then(loginResp => {
        const payload = get(loginResp, "data");
        if (payload.data.user.verified) {
          setLocalstorage("token", payload.data.jwtToken.accessToken || null);
          setLocalstorage("name", payload.data.user.name || null);
          setLocalstorage("user", payload.data.user || null);
          setLocalstorage("logoDTO", payload.data.user.logoDTO || null);
          setLocalstorage(
            "draftedProject",
            payload.data.user.projectDrafted || null
          );
          setLocalstorage(
            "needHelpEmails",
            payload.data.user.needHelpEmails || null
          );
          setLocalstorage("user", payload.data.user || null);
          setLocalstorage(
            "userSponsoredScheme",
            payload.data.user.sponsoredScheme === "STATE"
          );
          setLocalstorage(
            "groupCategory",
            payload.data.user.groupCategory || null
          );
        }
        dispatch({
          type: LOGIN_ACTION.LOGIN_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: LOGIN_ACTION.LOGIN_FAILURE
        });
      });
  };
};

export const userLoginGenerateOTP = (requestMethod = request, mobileNumber) => {
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.OTP_START
    });
    return requestMethod(apiServices.userLoginGenerateOTPParams(mobileNumber))
      .then(loginResp => {
        const payload = loginResp.data;
        dispatch({
          type: LOGIN_ACTION.OTP_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: LOGIN_ACTION.OTP_FAILURE
        });
      });
  };
};

export const userLoginGenerateOTPClear = () => {
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.OTP_MSG_CLEAR
    });
  };
};

export const userLogout = (requestMethod = request) => {
  return requestMethod(apiServices.userLogoutParams())
    .then(login => {
      const {
        status: { code }
      } = login.data;
      return code;
    })
    .catch(e => {
      console.log("Logout Failed", e.message);
    });
};

export const _userLogout = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.LOGOUT_START
    });
    return requestMethod(apiServices.userLogout(data))
      .then(res => {
        dispatch({
          type: LOGIN_ACTION.LOGOUT_SUCCESS,
          res
        });
        return res;
      })
      .catch(e => {
        dispatch({
          type: LOGIN_ACTION.LOGOUT_FAILURE
        });
        console.log(e, "error");
      });
  };
};

export const userForgetPassword = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: FORGET_ACTION.FORGET_START
    });
    return requestMethod(apiServices.userForgetPasswordParams(params))
      .then(res => {
        dispatch({
          type: FORGET_ACTION.FORGET_SUCCESS,
          res
        });
      })
      .catch(e => {
        dispatch({
          type: FORGET_ACTION.FORGET_FAILURE
        });
      });
  };
};

export const userResetPassword = (requestMethod = request, params) => {
  return requestMethod(apiServices.userResetPasswordParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Reset Password Failed", e.message);
    });
};

export const _storeLoginInfoInCookie = (cookies, loginInfo) => {
  if (loginInfo.isRememberMe === true) {
    CookieService.setCookie(cookies, "loginFormUserInfo", {
      username: loginInfo.username,
      password: loginInfo.password,
      isRememberMe: loginInfo.isRememberMe
    });
  } else {
    CookieService.removeCookie(cookies, "loginFormUserInfo");
  }
};

export const validateUserForResetPassAction = (
  requestMethod = request,
  token
) => {
  return requestMethod(apiServices.isUserValidForResetPassword(token))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("User Invalid for register password", e.message);
    });
};

export const sendVerificationOTP = (requestMethod = request, params) => {
  return requestMethod(apiServices.sendVerificationOTPParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Reset Password Failed", e.message);
    });
};
